import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import {
  ClientContact,
  ClientCreateResponse,
  ClientDataResponse
} from '../models/client/client.interface';

@Injectable({
  providedIn: 'root',
})
export class ClientContactService {
  constructor(private http: HttpClient) {}

  createClientContact(
    reqBody: any
  ): Observable<ClientDataResponse<ClientCreateResponse>> {
    return this.http.post<ClientDataResponse<ClientCreateResponse>>(
      `${environment.fireStoreApiUrl}/api/v1/client-contacts/`,
      reqBody
    );
  }

  getClientEmployees(
    limit: number,
    offSet: number,
    search?:string
  ): Observable<ClientDataResponse<any>> {
    return this.http.get<ClientDataResponse<any>>(
      `${environment.fireStoreApiUrl}/api/v1/employee/?limit=${limit}&offset=${offSet}&search=${search}`
    );
  }

  getClientContacts(
    limit: number,
    offSet: number,
    search?:string
  ): Observable<ClientDataResponse<any>> {
    return this.http.get<ClientDataResponse<any>>(
      `${environment.fireStoreApiUrl}/api/v1/client-contacts/?limit=${limit}&offset=${offSet}&search=${search}`
    );
  }

  getCaseServices(
    limit: number,
    offSet: number,
    search?:string
  ): Observable<any> {
    return this.http.get<any>(
      `${environment.fireStoreApiUrl}/api/v1/case-service/?limit=${limit}&offset=${offSet}&search=${search}`
    ).pipe(
      map((res) => res?.details?.hits || [])
    );
  }

  getClientContact(id: number): Observable<ClientDataResponse<ClientContact>> {
    return this.http.get<ClientDataResponse<ClientContact>>(
      `${environment.fireStoreApiUrl}/api/v1/client-contacts/${id}`
    );
  }

  getClientProgramNames(clientId: number,cityName:string): Observable<any> {
    return this.http.get<any>(
      `${environment.fireStoreApiUrl}/api/v1/clients/${clientId}/${cityName}/program-names`
    );
  }

  createClientContactProgram(
    reqBody: any
  ): Observable<ClientDataResponse<ClientCreateResponse>> {
    return this.http.post<ClientDataResponse<ClientCreateResponse>>(
      `${environment.fireStoreApiUrl}/api/v1/client-contact-programs/`,
      reqBody
    );
  }

  getClientContactPrograms(
    limit: number,
    offSet: number,
    clientContactId?:number
  ): Observable<ClientDataResponse<any>> {
    let url = `${environment.fireStoreApiUrl}/api/v1/client-contact-programs/?limit=${limit}&offset=${offSet}`;
    if(clientContactId){
      url = `${environment.fireStoreApiUrl}/api/v1/client-contact-programs/?limit=${limit}&offset=${offSet}&client_contact_id=${clientContactId}`
    }

    return this.http.get<ClientDataResponse<any>>(url);
  }

  getProgramLocationContacts(programLocationId: number): Observable<any>{
    return this.http.get<any>(
      `${environment.fireStoreApiUrl}/api/v1/clients/${programLocationId}/client_contacts`
    );

  }
}
